import { api } from "../lib/api";

// Trend Ranking Model — powers the Trending Looks Feed (rule-based via backend)
export async function rankTrendingLooks() {
  const { data } = await api.get("/trending");
  return data.looks;
}

// Recreate this look -> returns the occasion to prefill in the journey
export function recreateLook(look) {
  return { occasion: look.occasion, source: look.title };
}
